module.exports = __webpack_public_path__ + "img/icon-map.82a21a30.svg";